import React from 'react'
import {DateTime} from '@therms/react-modules'

interface RecordFieldProps {
  fieldType?: 'boolean' | 'datetime' | 'number' | 'select' | 'text' | 'textarea'
  value?: boolean | number | string
}

function RecordField({fieldType = 'text', value}: RecordFieldProps) {
  let valueDisplay: React.ReactNode = value

  if (typeof value === 'boolean') {
    valueDisplay = value ? 'Yes' : 'No'
  } else if (fieldType === 'datetime' && typeof value === 'string') {
    valueDisplay = <DateTime timestamp={value} mode="date" />
  }

  return (
    <div className="p-xs flex min-h-8 items-center justify-between">
      {valueDisplay}
    </div>
  )
}

export {RecordField}
